import { render, staticRenderFns } from "./home-skin.vue?vue&type=template&id=4817d8d6&scoped=true"
import script from "./home-skin.vue?vue&type=script&lang=js"
export * from "./home-skin.vue?vue&type=script&lang=js"
import style0 from "./home-skin.vue?vue&type=style&index=0&id=4817d8d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817d8d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4817d8d6')) {
      api.createRecord('4817d8d6', component.options)
    } else {
      api.reload('4817d8d6', component.options)
    }
    module.hot.accept("./home-skin.vue?vue&type=template&id=4817d8d6&scoped=true", function () {
      api.rerender('4817d8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/home-skin.vue"
export default component.exports